import Customer from "models/Customer";

export const OPEN = "customerModal/OPEN";
export const CLOSE = "customerModal/CLOSE";
export const CHANGE_FORM = "customerModal/CHANGE_FORM";
export const SET_ERRORS = "customerModal/SET_ERRORS";
export const CHANGE_SELECTED_LOCALES = "customerModal/CHANGE_SELECTED_LOCALES";

export const openCustomerModal = customer => ({
  type: OPEN,
  customer
});

export const closeCustomerModal = () => ({
  type: CLOSE
});

export const changeCustomerForm = (key, value) => ({
  type: CHANGE_FORM,
  key,
  value
});

export const changeSelectedLocales = id => ({
  type: CHANGE_SELECTED_LOCALES,
  id
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

const initialState = {
  open: false,
  customer: new Customer(),
  errors: [],
  industries: []
};

const customerModal = (state = initialState, action) => {
  switch (action.type) {
    case OPEN:
      return {
        ...state,
        open: true,
        customer: new Customer(action.customer),
        errors: initialState.errors
      };
    case CLOSE:
      return { ...state, open: false };
    case CHANGE_FORM: {
      const { key, value } = action;
      return { ...state, customer: state.customer.set(key, value) };
    }
    case SET_ERRORS: {
      const { errors } = action;
      return { ...state, errors };
    }
    case CHANGE_SELECTED_LOCALES: {
      const { selectedLocaleIds } = state.customer;
      const selectedId = Number(action.id);
      let newSelectedLocales = [];

      if (selectedLocaleIds.indexOf(selectedId) > -1) {
        newSelectedLocales = selectedLocaleIds.filter(id => id !== selectedId);
      } else {
        newSelectedLocales = [...selectedLocaleIds, selectedId];
      }

      const customer = state.customer.set(
        "selectedLocaleIds",
        newSelectedLocales
      );
      return { ...state, customer };
    }
    default:
      return state;
  }
};

export default customerModal;



// WEBPACK FOOTER //
// ./src/redux/modules/customerModal.js